export default "__VITE_ASSET__81a9739f__"